import * as React from "react"

function SvgLockCircle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 21 21"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.833}
      >
        <path d="M6.25 8.78a.834.834 0 01.83-.838h.003l5.839.004c.458 0 .83.37.833.829v4.15c0 .458-.37.83-.83.833l-5.833.027a.834.834 0 01-.833-.833L6.25 8.779zm3.762 3.328l-.009-2.291M7.508 7.942V7.12a2.501 2.501 0 015-.023v.845" />
        <path d="M10 9.608a.21.21 0 01.21.206v.002a.208.208 0 01-.207.209H10a.207.207 0 01-.21-.206v-.002a.21.21 0 01.21-.209" />
        <path d="M10.003.442c5.293 0 9.584 4.29 9.584 9.583s-4.291 9.583-9.584 9.583c-5.292 0-9.583-4.29-9.583-9.583S4.71.442 10.003.442z" />
      </g>
    </svg>
  )
}

export default SvgLockCircle
